var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "persona--section -mt-12 sm-md:mt-0"
  }, [_c('div', {
    staticClass: "section--container"
  }, [!_vm.standalone ? _c('div', {
    staticClass: "container max-w-3xl section--content"
  }, [_vm.inquiryOnHold ? [_c('h1', {
    staticClass: "my-6"
  }, [_vm._v("We're reviewing your documents")]), _vm._v(" "), _c('p', {
    staticClass: "my-8 text-xl leading-8"
  }, [_vm._v("\n\t\t\t\t\tThanks for your patience — our team is reviewing your verification and will reach out by\n\t\t\t\t\temail if we need anything else from you.\n\t\t\t\t")])] : [_c('h1', {
    staticClass: "my-6"
  }, [_vm._v("Almost there!")]), _vm._v(" "), _c('p', {
    staticClass: "my-8 text-xl leading-8"
  }, [_vm._v("\n\t\t\t\t\tNext, let’s confirm your identity. In the next few screens, we will need a selfie as\n\t\t\t\t\twell as a few other things to make sure you are you.\n\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button--filled mt-8 sm:w-full",
    attrs: {
      "disabled": !_vm.persona
    },
    on: {
      "click": _vm.openPersona
    }
  }, [_vm._v("\n\t\t\t\t\tContinue\n\t\t\t\t")])]], 2) : _vm._e()])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };